import { ErrorPageLayout } from '../components/ErrorPageLayout';

const InternalErrorPage = () => <ErrorPageLayout errorType={500} />;

export default InternalErrorPage;
